/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Systems_DirectorInputs */



/**
* | output |
* | --- |
* | "Systems Director" |
*
* @param {Team_Role_Systems_DirectorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_role_systems_director = /** @type {((inputs?: Team_Role_Systems_DirectorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Systems_DirectorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("系统总监")
	return /** @type {LocalizedString} */ ("Systems Director")
});